
import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator'
import type { HomeOffer, MobileOffer, BundleOffer } from '@alao-frontend/core'
import { NamedOfferCategoryType, OfferCategoryType } from '@alao-frontend/core'
import BundleOfferCard from '~/components/offers/OfferCard/BundleOfferCard'
import HomeOfferCard from '~/components/offers/OfferCard/HomeOfferCard'
import MobileOfferCard from '~/components/offers/OfferCard/MobileOfferCard'
import NewOfferCard from '~/components/offers/NewOfferCard/OfferCard.vue'
import PromoOfferCard from '~/components/offers/OfferCard/Promo/PromoOfferCard.vue'
import type { AdditionalQueryParams } from '~/core/osp/additional-query-params'
import { plainObjectToRouteQueryObject } from '~/core/osp/additional-query-params'
import type { TooltipTrigger } from '~/components/AppTooltip.vue'
import { getExternalCompareMobileSlugHref, getExternalCompareHomeSlugHref, getExternalCompareBundleSlugHref } from '~/utils/external-links.utils'

@Component
export default class OfferCard extends Vue {
  @Prop({ required: true, type: Object })
  readonly offer?: HomeOffer | MobileOffer | BundleOffer

  @Prop({ required: false, type: Object, default: () => ({}) })
  readonly additionalParams!: AdditionalQueryParams

  @Prop({ required: false, type: Boolean, default: true })
  readonly clickable!: boolean

  @Prop({ required: false, type: Boolean, default: false })
  readonly showNewMobileCardsInfo!: boolean

  @Prop({
    default: 'hover',
    type: String,
  })
  readonly pricesTooltipTrigger!: TooltipTrigger

  @Prop({
    default: false,
    type: Boolean,
  })
  readonly promo!: boolean

  @Prop({
    default: false,
    type: Boolean,
  })
  readonly newOfferCard!: boolean

  @Prop({
    default: false,
    type: Boolean,
  })
  readonly topDeal!: boolean

  get component () {
    if (!this.offer) {
      return 'span'
    }

    const constructor = this.offer.constructor as
      | typeof HomeOffer
      | typeof MobileOffer
      | typeof BundleOffer
    switch (constructor.offerType) {
      case OfferCategoryType.MOBILE_ABO_OFFER:
        return this.promo ? PromoOfferCard : this.newOfferCard ? NewOfferCard : MobileOfferCard

      case OfferCategoryType.HOME_OFFER:
        return this.promo ? PromoOfferCard : this.newOfferCard ? NewOfferCard : HomeOfferCard

      case OfferCategoryType.BUNDLE_OFFER:
        return this.newOfferCard ? NewOfferCard : BundleOfferCard

      default:
        throw new Error('Unreachable offer type')
    }
  }

  get url () {
    if (!this.offer) {
      return ''
    }

    const additionalParams = plainObjectToRouteQueryObject(this.additionalParams)

    // Формируем базовую внешнюю ссылку
    let externalUrl: string
    const constructor = this.offer.constructor as any
    switch (constructor.offerType) {
      case OfferCategoryType.MOBILE_ABO_OFFER:
        externalUrl = getExternalCompareMobileSlugHref(this.$config.BASE_URL, this.localePath, this.offer.slug)
        break
      case OfferCategoryType.HOME_OFFER:
        externalUrl = getExternalCompareHomeSlugHref(this.$config.BASE_URL, this.localePath, this.offer.slug)
        break
      case OfferCategoryType.BUNDLE_OFFER:
        externalUrl = getExternalCompareBundleSlugHref(this.$config.BASE_URL, this.localePath, this.offer.slug)
        break
      default:
        return ''
    }

    // Добавляем дополнительные параметры к URL
    if (Object.keys(additionalParams).length > 0) {
      const queryString = new URLSearchParams(additionalParams as Record<string, string>).toString()
      externalUrl += `?${queryString}`
    }

    return externalUrl
  }

  @Emit('click')
  onClick () {
    return true
  }
}
